<template>
  <Card :title="title" containerClass="mb-5 shadow-sm">
      <template #cardBody>
        <div class="row">
          <label class="form-label fs-6 text-black mb-5">{{ $t('reminder_config_input') }}<span class="text-danger"> * </span></label>
          <div class="input-group">
              <Input
                containerClass="form-group col-12 col-md-3 col-lg-3 mt-auto mb-5"
                :name="`frequence_number`+id"
                type="number"
                :inputClass="'form-control form-control-lg form-control-solid'"
                :isRequired="true"
                :placeholder="$t('appointments.label.placeholder_reminder_number')"
                v-model="formData.frequency_count"
                :min="1"
              />
              <Select2
                  container-class="form-group col-12 col-md-9 col-lg-9 mt-auto mb-5"
                  :multiple="false"
                  :show-search="true"
                  :selectClass="'form-select form-control-sm form-select-solid'"
                  :name="`reminder`+id"
                  :isRequired="true"
                  :placeholder-text="$t('appointments.label.placeholder_reminder')"
                  v-model="formData.frequency"
              >
                <option v-for="(item, index) in frequencyEnum" :key="index" :value="item.value">
                  {{ item[locale] }}
                </option>
              </Select2>
          </div>
        </div>
      </template>
      <template #cardFooter>
        <div class="d-flex justify-content-end" v-if="$can(abilities.REMIND_CONFIG_CREATE)">
          <Button btn-class="btn-sm" type="new" id="submit_btn" size="7px 30px" btn-text="setting.button" @click.prevent="submitForm" :isLoading="isLoading"></Button>
        </div>
      </template>
  </Card>
</template>

<script setup>
import {useStore} from "vuex";
import {ref, defineProps, onMounted, computed} from 'vue'
import { useLocales } from "@/composables/locales";
import Button from "@/components/Button"
import Card from "@/Modules/CRM/components/Card.vue";
import Select2 from "@/components/Select2.vue";
import Input from "@/components/Input.vue";
import abilities from "@/composables/abilities";

const {locale} = useLocales()
const store = useStore()

const emits = defineEmits(['submit'])

const props = defineProps({
  id: {
    type: String,
    default: ''
  },
  title: {
    type: String,
  },
  form: {
    type: Object,
    default: {
      frequency: '',
      frequency_count: '',
      context: ''
    }
  },
  isLoading: {
    type: Boolean,
    default: false
  }
}) 

const formData = ref(props.form)
const getReminder = ref({})
const frequencyEnum = computed(() => store.getters["configs/getFrequencyEnum"])

function submitForm(){
  emits('submit')
}

onMounted(() => {
  store.dispatch('configs/loadFrequencyEnum')
  store.dispatch('configs/getContextFrequency').then((res) => {
    getReminder.value = res.data

    getReminder.value?.filter((item) => {
      if(item.context?.value == props.id){
        formData.value.context = item.context?.value
        formData.value.frequency = item.frequency?.value
        formData.value.frequency_count = item.frequency_count
      }
    })
  })
})
</script>

<style scoped>
</style>
